import React, { useState } from "react";
import Loading from "../general/Loading";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Grid,
    TextField,
    MenuItem,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";

// CSS styling
const useStyles = makeStyles({
  customer: {
    width: 300,
  },
  status: {
    width: 150,
  },
  selector: {
    width: 200,
  },
});

// Render the form to output Customer Statement
export default function CustomerStatementForm(){
  // Form inputs
  const classes = useStyles();
  const navigate = useNavigate();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [customer, setCustomer] = useState("");
  const [status, setStatus] = useState("");

  // Change fetchUrl to user input and redirect
  const handleSubmit = (event) => {
    event.preventDefault();

    // Navigate to Customer Statement Report form with specified query parameters
    navigate("/customerstatement/report" +
      "?dateStart=" + startDate + 
      "&dateEnd=" + endDate +
      "&customer=" + customer + 
      "&orderStatus=" + status
      );
  };

  // Resets the fetch URL with no filters
  const handleClear = () => {
    setStartDate("");
    setEndDate("");
    setCustomer("");
    setStatus("");
  };

  // Render content
  return(
    <form
      autoComplete="off"
      noValidate
      onSubmit={(event) => handleSubmit(event)}
    >
      <Grid
        container
        spacing={3}
        alignItems="flex-start"
        justifyContent="flex-start"
        direction="column"
      >
        {/* Date Selector Title Row */}
        <Grid container item spacing={1}>
            {/* Start Date Title */}
            <Grid item xs={6} sm={2.5}>
              <Typography component="h3" variant="h6">
                Start Date
              </Typography>
            </Grid>
            {/* End Date Title */}
            <Grid item xs={6} sm={2.5}>
              <Typography component="h3" variant="h6">
                End Date
              </Typography>
            </Grid>
        </Grid>

        {/* Date Textfield Row */}
        <Grid container item spacing={1}>
            {/* Start Date Textfield */}
            <Grid item xs={6} sm={2.5}>
              <TextField
                variant="outlined"
                label="from"
                type="date"
                value={startDate}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => setStartDate(event.target.value)}
                sx={{ width: "50%"}}
                fullWidth
              />
            </Grid>
            {/* End Date Textfield */}
            <Grid item xs={6} sm={2.5}>
              <TextField
                variant="outlined"
                label="to"
                type="date"
                value={endDate}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => setEndDate(event.target.value)}
                sx={{ width: "50%"}}
                fullWidth
              />
            </Grid>
        </Grid>

        <Grid container item spacing={1}>
          {/* Customer Code Title Row */}
          <Grid container item xs={6} sm={2.5}>
            <Typography component="h4" variant="h6">
                Customer Code
            </Typography>
          </Grid>
          {/* Status Dropdown Title Row */}
          <Grid container item xs={6} sm={2.5}>
            <Typography component="h4" variant="h6">
                Status
            </Typography>
          </Grid>
        </Grid>

        <Grid container item spacing={1}>
          {/* Customer Code Textfield */}
          <Grid item xs={6} sm={2.5}>
            <TextField
            variant="outlined"
            label="Customer Code"
            value={customer}
            onChange={(event) => setCustomer(event.target.value)}
            />
          </Grid>
          {/* Status Dropdown */}
          <Grid item xs={6} sm={2.5}>
            <TextField
              className={classes.status}
              label="Status"
              onChange={(event) => setStatus(event.target.value)}
              value={status}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              select
            >
              <MenuItem value="">
                All
              </MenuItem>
              <MenuItem value="C">Closed</MenuItem>
              <MenuItem value="O">Open</MenuItem>
            </TextField>
          </Grid>
        </Grid>

        <Grid container item spacing={1}>
          {/* Form Submission Button */}
          <Grid container item xs={6} sm={2.5}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              size="large"
            >
              Generate Report
            </Button>
          </Grid>
          {/* Reset Button */}
          <Grid container item xs={6} sm={2.5}>
            <Button
              variant="contained"
              color="secondary"
              type="button"
              size="large"
              onClick={handleClear}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}